import { z } from 'zod'

export const paramsSchema = z.object({
  outingId: z.string().min(1),
  cottageUid: z.string().min(1),
  note: z.string().nullable().optional(),
  createdBy: z.string().min(1),
})

export type paramsType = z.infer<typeof paramsSchema>
